<template>
  <div class="container sv018">
    <breadcrumb-group :items="breadcrumbItems" />

    <HeadingOne>ご利用可能な金融機関</HeadingOne>

    <p>
      お借り入れ金額のお受取りや、ご返済金のお引落しにご利用いただける金融機関は以下のとおりです。
    </p>

    <!--<contents-card class="-orange _mb-10">-->
    <!--<div class="CardHeader">-->
    <!--<h3 class="heading -orange">ご利用可能時間</h3>-->
    <!--</div>-->
    <!--<div class="CardBody _pt-md-30">-->
    <!--<div class="CardGroups">-->
    <!--<div class="CardBox">-->
    <!--<p class="txt01 _mb-sm-20"><span class="txt02 -orange">お借り入れ</span>8:00～14:59</p>-->
    <!--</div>-->
    <!--<div class="CardBox">-->
    <!--<p class="txt01"><span class="txt02 -green">ご返済</span>8:00～14:59</p>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</contents-card>-->

    <section>
      <HeadingTwo>主な金融機関</HeadingTwo>

      <!--<div class="main-bank01 _mb-md-30 _mb-sm-10">-->
      <!--<div class="img-box _mr-md-20 _pr-sm-10">-->
      <!--<img src="@/assets/images/sv/sv018/img01.gif" class="img-fluid" alt="">-->
      <!--</div>-->
      <!--<div class="img-box _ml-md-20 _pl-sm-10">-->
      <!--<img src="@/assets/images/sv/sv018/img02.gif" class="img-fluid" alt="">-->
      <!--</div>-->
      <!--</div>-->

      <TableBox class="_mb-md-120 _mb-sm-60">
        <TableBody>
          <TableRow>
            <TableData>auじぶん銀行</TableData>
            <TableData>三菱ＵＦＪ銀行</TableData>
            <TableData>三井住友銀行</TableData>
            <TableData>みずほ銀行</TableData>
            <TableData>ゆうちょ銀行</TableData>
            <TableData>りそな銀行</TableData>
            <TableData>埼玉りそな銀行</TableData>
            <TableData>セブン銀行</TableData>
          </TableRow>
        </TableBody>
      </TableBox>

      <HeadingTwo>地方銀行</HeadingTwo>

      <CardGroups class="_mb-md-120 _mb-sm-60">
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="chiho-hokkaido" class="-plus">
              <h3 class="heading">北海道・東北地方</h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="chiho-hokkaido">
            <CardBody>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>北海道銀行</TableData>
                    <TableData>北洋銀行</TableData>
                    <TableData>青森みちのく銀行</TableData>
                    <TableData>秋田銀行</TableData>
                    <TableData>北都銀行</TableData>
                    <TableData>荘内銀行</TableData>
                    <TableData>山形銀行</TableData>
                    <TableData>きらやか銀行</TableData>
                    <TableData>岩手銀行</TableData>
                    <TableData>東北銀行</TableData>
                    <TableData>北日本銀行</TableData>
                    <TableData>七十七銀行</TableData>
                    <TableData>仙台銀行</TableData>
                    <TableData>東邦銀行</TableData>
                    <TableData>福島銀行</TableData>
                    <TableData>大東銀行</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
          </CollapseItem>
        </CardBox>
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="chiho-kanto" class="-plus">
              <h3 class="heading">関東地方</h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="chiho-kanto">
            <CardBody>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>群馬銀行</TableData>
                    <TableData>東和銀行</TableData>
                    <TableData>足利銀行</TableData>
                    <TableData>栃木銀行</TableData>
                    <TableData>常陽銀行</TableData>
                    <TableData>筑波銀行</TableData>
                    <TableData>武蔵野銀行</TableData>
                    <TableData>千葉銀行</TableData>
                    <TableData>千葉興業銀行</TableData>
                    <TableData>京葉銀行</TableData>
                    <TableData>きらぼし銀行</TableData>
                    <TableData>東日本銀行</TableData>
                    <TableData>東京スター銀行</TableData>
                    <TableData>横浜銀行</TableData>
                    <TableData>神奈川銀行</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
          </CollapseItem>
        </CardBox>
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="chiho-cyubu" class="-plus">
              <h3 class="heading">中部地方</h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="chiho-cyubu">
            <CardBody>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>第四北越銀行</TableData>
                    <TableData>大光銀行</TableData>
                    <TableData>山梨中央銀行</TableData>
                    <TableData>八十二銀行</TableData>
                    <TableData>長野銀行</TableData>
                    <TableData>北陸銀行</TableData>
                    <TableData>富山銀行</TableData>
                    <TableData>富山第一銀行</TableData>
                    <TableData>北國銀行</TableData>
                    <TableData>福井銀行</TableData>
                    <TableData>福邦銀行</TableData>
                    <TableData>静岡銀行</TableData>
                    <TableData>スルガ銀行</TableData>
                    <TableData>清水銀行</TableData>
                    <TableData>静岡中央銀行</TableData>
                    <TableData>大垣共立銀行</TableData>
                    <TableData>十六銀行</TableData>
                    <TableData>あいち銀行</TableData>
                    <TableData>名古屋銀行</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
          </CollapseItem>
        </CardBox>
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="chiho-kansai" class="-plus">
              <h3 class="heading">関西地方</h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="chiho-kansai">
            <CardBody>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>三十三銀行</TableData>
                    <TableData>百五銀行</TableData>
                    <TableData>滋賀銀行</TableData>
                    <TableData>京都銀行</TableData>
                    <TableData>関西みらい銀行</TableData>
                    <TableData>池田泉州銀行</TableData>
                    <TableData>南都銀行</TableData>
                    <TableData>紀陽銀行</TableData>
                    <TableData>但馬銀行</TableData>
                    <TableData>みなと銀行</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
          </CollapseItem>
        </CardBox>
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="chiho-cyugoku" class="-plus">
              <h3 class="heading">中国地方</h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="chiho-cyugoku">
            <CardBody>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>鳥取銀行</TableData>
                    <TableData>島根銀行</TableData>
                    <TableData>山陰合同銀行</TableData>
                    <TableData>中国銀行</TableData>
                    <TableData>トマト銀行</TableData>
                    <TableData>広島銀行</TableData>
                    <TableData>もみじ銀行</TableData>
                    <TableData>山口銀行</TableData>
                    <TableData>西京銀行</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
          </CollapseItem>
        </CardBox>
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="chiho-shikoku" class="-plus">
              <h3 class="heading">四国地方</h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="chiho-shikoku">
            <CardBody>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>阿波銀行</TableData>
                    <TableData>徳島大正銀行</TableData>
                    <TableData>百十四銀行</TableData>
                    <TableData>香川銀行</TableData>
                    <TableData>伊予銀行</TableData>
                    <TableData>愛媛銀行</TableData>
                    <TableData>四国銀行</TableData>
                    <TableData>高知銀行</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
          </CollapseItem>
        </CardBox>
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="chiho-kyusyu" class="-plus">
              <h3 class="heading">九州・沖縄地方</h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="chiho-kyusyu">
            <CardBody>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>福岡銀行</TableData>
                    <TableData>筑邦銀行</TableData>
                    <TableData>西日本シティ銀行</TableData>
                    <TableData>北九州銀行</TableData>
                    <TableData>福岡中央銀行</TableData>
                    <TableData>佐賀銀行</TableData>
                    <TableData>佐賀共栄銀行</TableData>
                    <TableData>十八親和銀行</TableData>
                    <TableData>長崎銀行</TableData>
                    <TableData>肥後銀行</TableData>
                    <TableData>熊本銀行</TableData>
                    <TableData>大分銀行</TableData>
                    <TableData>豊和銀行</TableData>
                    <TableData>宮崎銀行</TableData>
                    <TableData>宮崎太陽銀行</TableData>
                    <TableData>鹿児島銀行</TableData>
                    <TableData>南日本銀行</TableData>
                    <TableData>琉球銀行</TableData>
                    <TableData>沖縄銀行</TableData>
                    <TableData>沖縄海邦銀行</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
          </CollapseItem>
        </CardBox>
      </CardGroups>
    </section>

    <section>
      <HeadingTwo>その他（ネット銀行など）</HeadingTwo>

      <TableBox class="_mb-md-120 _mb-sm-60">
        <TableBody>
          <TableRow>
            <TableData>ソニー銀行</TableData>
            <TableData>楽天銀行</TableData>
            <TableData>住信SBIネット銀行</TableData>
            <TableData>イオン銀行</TableData>
            <TableData>GMOあおぞらネット銀行</TableData>
            <TableData>SBI新生銀行</TableData>
            <TableData>ゆうちょ銀行</TableData>
          </TableRow>
        </TableBody>
      </TableBox>
    </section>

    <section>
      <HeadingTwo>信用金庫</HeadingTwo>
      <p class="_mb-md-120">
        全国の信用金庫で、お借り入れ金額のお受取りや、ご返済金のお引落しにご利用可能です。
      </p>
    </section>

    <section>
      <HeadingTwo>信用組合</HeadingTwo>
      <CardGroups class="_mb-md-120 _mb-sm-60">
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="rokin-hokkaido" class="-plus">
              <h3 class="heading">北海道、東北地方</h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="rokin-hokkaido">
            <CardBody>
              <p class="ttl">北海道</p>
              <TableBox class="mb-10">
                <TableBody>
                  <TableRow>
                    <TableData>北央信用組合</TableData>
                    <TableData>札幌中央信用組合</TableData>
                    <TableData>ウリ信用組合</TableData>
                    <TableData>函館商工信用組合</TableData>
                    <TableData>空知商工信用組合</TableData>
                    <TableData>十勝信用組合</TableData>
                    <TableData>釧路信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">青森県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>青森県信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">宮城県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>石巻商工信用組合</TableData>
                    <TableData>古川信用組合</TableData>
                    <TableData>仙北信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">秋田県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>秋田県信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">山形県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>北郡信用組合</TableData>
                    <TableData>山形中央信用組合</TableData>
                    <TableData>山形第一信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">福島県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>福島県商工信用組合</TableData>
                    <TableData>いわき信用組合</TableData>
                    <TableData>相双五城信用組合</TableData>
                    <TableData>会津商工信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
          </CollapseItem>
        </CardBox>
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="rokin-kanto" class="-plus">
              <h3 class="heading">関東地方</h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="rokin-kanto">
            <CardBody>
              <p class="ttl">茨城県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>茨城県信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">栃木県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>真岡信用組合</TableData>
                    <TableData>那須信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">群馬県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>あかぎ信用組合</TableData>
                    <TableData>群馬県信用組合</TableData>
                    <TableData>ぐんまみらい信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">埼玉県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>熊谷商工信用組合</TableData>
                    <TableData>埼玉信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">千葉県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>房総信用組合</TableData>
                    <TableData>銚子商工信用組合</TableData>
                    <TableData>君津信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">東京都</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>あすか信用組合</TableData>
                    <TableData>全東栄信用組合</TableData>
                    <TableData>東京厚生信用組合</TableData>
                    <TableData>東信用組合</TableData>
                    <TableData>江東信用組合</TableData>
                    <TableData>青和信用組合</TableData>
                    <TableData>中ノ郷信用組合</TableData>
                    <TableData>共立信用組合</TableData>
                    <TableData>七島信用組合</TableData>
                    <TableData>大東京信用組合</TableData>
                    <TableData>第一勧業信用組合</TableData>
                    <TableData>警視庁職員信用組合</TableData>
                    <TableData>東京消防信用組合</TableData>
                    <TableData>東京都職員信用組合</TableData>
                    <TableData>ハナ信用組合</TableData>
                    <TableData>朝日新聞信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">神奈川県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>神奈川県医師信用組合</TableData>
                    <TableData>神奈川県歯科医師信用組合</TableData>
                    <TableData>横浜幸銀信用組合</TableData>
                    <TableData>信用組合横浜華銀</TableData>
                    <TableData>小田原第一信用組合</TableData>
                    <TableData>相愛信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
          </CollapseItem>
        </CardBox>
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="rokin-cyubu" class="-plus">
              <h3 class="heading">中部地方</h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="rokin-cyubu">
            <CardBody>
              <p class="ttl">新潟県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>新潟縣信用組合</TableData>
                    <TableData>新潟鉄道信用組合</TableData>
                    <TableData>興栄信用組合</TableData>
                    <TableData>はばたき信用組合</TableData>
                    <TableData>協栄信用組合</TableData>
                    <TableData>三條信用組合</TableData>
                    <TableData>巻信用組合</TableData>
                    <TableData>新潟大栄信用組合</TableData>
                    <TableData>ゆきぐに信用組合</TableData>
                    <TableData>糸魚川信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">山梨県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>山梨県民信用組合</TableData>
                    <TableData>都留信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">長野県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>長野県信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">富山県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>富山県医師信用組合</TableData>
                    <TableData>富山県信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">石川県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>金沢中央信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">福井県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>福泉信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">愛知県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>信用組合愛知商銀</TableData>
                    <TableData>愛知県警察信用組合</TableData>
                    <TableData>豊橋商工信用組合</TableData>
                    <TableData>愛知県中央信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">岐阜県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>岐阜商工信用組合</TableData>
                    <TableData>イオ信用組合</TableData>
                    <TableData>飛騨信用組合</TableData>
                    <TableData>益田信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
          </CollapseItem>
        </CardBox>
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="rokin-kansai" class="-plus">
              <h3 class="heading">関西地方</h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="rokin-kansai">
            <CardBody>
              <p class="ttl">滋賀県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>滋賀県民信用組合</TableData>
                    <TableData>滋賀県信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">京都府</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>京滋信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">大阪府</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>大同信用組合</TableData>
                    <TableData>成協信用組合</TableData>
                    <TableData>大阪貯蓄信用組合</TableData>
                    <TableData>のぞみ信用組合</TableData>
                    <TableData>大阪府医師信用組合</TableData>
                    <TableData>大阪府警察信用組合</TableData>
                    <TableData>近畿産業信用組合</TableData>
                    <TableData>ミレ信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">兵庫県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>兵庫県警察信用組合</TableData>
                    <TableData>兵庫県医療信用組合</TableData>
                    <TableData>兵庫県信用組合</TableData>
                    <TableData>淡陽信用組合</TableData>
                    <TableData>兵庫ひまわり信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
          </CollapseItem>
        </CardBox>
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="rokin-cyugoku" class="-plus">
              <h3 class="heading">中国地方</h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="rokin-cyugoku">
            <CardBody>
              <p class="ttl">島根県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>島根益田信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">岡山県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>朝銀西信用組合</TableData>
                    <TableData>笠岡信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">広島県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>広島市信用組合</TableData>
                    <TableData>広島県信用組合</TableData>
                    <TableData>信用組合広島商銀</TableData>
                    <TableData>両備信用組合</TableData>
                    <TableData>備後信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">山口県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>山口県信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
          </CollapseItem>
        </CardBox>
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="rokin-shikoku" class="-plus">
              <h3 class="heading">四国地方</h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="rokin-shikoku">
            <CardBody>
              <p class="ttl">香川県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>香川県信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">高知県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>土佐信用組合</TableData>
                    <TableData>宿毛商銀信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
          </CollapseItem>
        </CardBox>
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="rokin-kyusyu" class="-plus">
              <h3 class="heading">九州、沖縄地方</h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="rokin-kyusyu">
            <CardBody>
              <p class="ttl">福岡県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>福岡県信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">佐賀県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>佐賀東信用組合</TableData>
                    <TableData>佐賀西信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">長崎県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>長崎三菱信用組合</TableData>
                    <TableData>西海みずき信用組合</TableData>
                    <TableData>福江信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">熊本県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>熊本県信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">大分県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>大分県信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">宮崎県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>宮崎県南部信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
            <CardBody>
              <p class="ttl">鹿児島県</p>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableData>鹿児島興業信用組合</TableData>
                    <TableData>奄美信用組合</TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </CardBody>
          </CollapseItem>
        </CardBox>
      </CardGroups>
    </section>

    <section>
      <HeadingTwo>労働金庫</HeadingTwo>
      <TableBox class="_mb-md-120 _mb-sm-60">
        <TableBody>
          <TableRow>
            <TableData>北海道労働金庫</TableData>
            <TableData>東北労働金庫</TableData>
            <TableData>中央労働金庫</TableData>
            <TableData>新潟県労働金庫</TableData>
            <TableData>長野県労働金庫</TableData>
            <TableData>静岡県労働金庫</TableData>
            <TableData>北陸労働金庫</TableData>
            <TableData>東海労働金庫</TableData>
            <TableData>近畿労働金庫</TableData>
            <TableData>中国労働金庫</TableData>
            <TableData>四国労働金庫</TableData>
            <TableData>九州労働金庫</TableData>
            <TableData>沖縄県労働金庫</TableData>
          </TableRow>
        </TableBody>
      </TableBox>
      <div class="_textright">
        <small>※2025年1月6日時点</small>
      </div>
    </section>

    <section class="_mb-md-120 _mb-sm-60">
      <ListGroup class="-note">
        <ListItem class="-note"
          >以下の金融機関は、お申し込み時にはご登録いただけません。
          <ListGroup>
            <ListItem class="-note">SBI新生銀行・あいち銀行・農業協同組合・ソニー銀行・楽天銀行・イオン銀行・ウリ信用組合・ハナ信用組合・イオ信用組合・ミレ信用組合</ListItem>
          </ListGroup>
        </ListItem>
        <ListItem class="-note"
          >金融機関の口座は、新規お申し込み時、または、ご契約後に会員さま専用サイトにてご登録いただけます。</ListItem
        >
        <ListItem class="-note"
          >ご契約後にご登録される場合は、会員さま専用サイトにログインのうえ「口座情報の登録・変更」よりお手続きください。</ListItem
        >
      </ListGroup>
      <ListGroup class="-link">
        <ListItem class="-link" router-name="ce001"
          >「口座情報の登録・変更」はこちら</ListItem
        >
      </ListGroup>
    </section>

    <CvBox class="_mb-md-120 _mb-sm-60" />

    <ContactBox class="_mb-md-120 _mb-sm-60" />
  </div>
  <!-- container -->
</template>

<script>
import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import BtnToggle from "@/components/button/BtnToggle";
import CardGroups from "@/components/card/CardGroups";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import CardBody from "@/components/card/CardBody";
import CollapseItem from "@/components/collapse/CollapseItem";
import CvBox from "@/components/box/CvBox";
import ContactBox from "@/components/box/ContactBox";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableData from "@/components/tables/TableData";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import { setMeta } from "@/utils/Meta";

export default {
  name: "Sv018",
  components: {
    ListItem,
    ListGroup,
    TableData,
    TableRow,
    TableBody,
    TableBox,
    ContactBox,
    CvBox,
    CollapseItem,
    CardBody,
    CardHeader,
    CardBox,
    CardGroups,
    BtnToggle,
    HeadingOne,
    HeadingTwo,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "ご利用可能な金融機関｜お申し込み条件・お手続きの流れ",
      description:
        "au PAY スマートローンでご利用可能な金融機関についてご案内します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,お申込み,金融機関,銀行",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "お申し込み条件・お手続きの流れ",
          routerName: "sv045",
        },
        {
          text: "ご利用可能な金融機関",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.contents-card {
  > .card-body {
    background-color: #fff;
    border-radius: 10px;
    padding: 25px;
    @include mq-up(md) {
      padding: 30px 50px;
    }
    > .card-groups {
      display: flex;
      @include mq-down(md) {
        flex-wrap: wrap;
      }
      @include mq-up(md) {
        justify-content: space-between;
        align-items: center;
      }
      > .card-box {
        width: 100%;
        @include mq-up(md) {
          width: 50%;
        }
        > .txt01 {
          font-size: 20px;
          word-break: break-all;
          text-align: center;
          margin-bottom: 0;
          @include mq-down(md) {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          @include mq-up(md) {
            font-size: 24px;
          }
          > .txt02 {
            padding-top: 5px;
            padding-bottom: 5px;
            max-width: 100px;
            width: 100%;
            display: inline-block;
            font-size: 14px;
            color: #fff;
            border-radius: 5px;
            margin-right: 20px;
            @include mq-up(md) {
              max-width: 140px;
              margin-right: 30px;
              font-size: 16px;
            }
          }
          > .-orange {
            background-color: $orange;
          }
          > .-green {
            background-color: $green;
          }
        }
      }
    }
  }
}
.main-bank01 {
  display: flex;
  justify-content: center;
  .img-box {
    width: 50%;
    @include mq-up(md) {
      max-width: 270px;
      width: 100%;
    }
  }
}
.main-bank02 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 60px;
  @include mq-down(md) {
    flex-wrap: wrap;
  }
  @include mq-up(md) {
    margin-bottom: 120px;
  }
  .img-box {
    width: 50%;
    @include mq-up(md) {
      max-width: 270px;
      width: 100%;
    }
  }
}

.ttl {
  font-weight: bold;
}

.table-box {
  table-layout: fixed;
  border: 0 !important;
  > .table-body {
    > .table-row {
      display: flex;
      flex-wrap: wrap;
      > .table-data {
        width: 100%;
        max-width: 50%;
        text-align: center;
        padding: 15px 20px;
        border: 1px solid #cccccc !important;
        margin-left: -1px;
        margin-bottom: -1px;
        display: flex;
        align-items: center;
        justify-content: center;
        @include mq-up(md) {
          padding: 25px 20px;
          max-width: 16.75%;
        }
      }
    }
  }
}
</style>
